// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });

      this.additionalProductConfigurationInputs = this.querySelectorAll(
        'additional-product-configuration'
      );
      this.additionalProductConfigurationInputs.forEach((input) => {
        input.addEventListener('change', (e) => {
          this.handleAdditionalProductConfigurationInput(e);
        });
      });
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      if (!this.productFormQuantity) {
        return false;
      }
      this.productFormQuantity.value = this.quantityInputElement.value;
    }

    /**
     * handleAdditionalProductConfigurationInput
     * @description Handle the change event of the additional product configuration inputs.
     * @param {Event} e - The change event.
     */
    handleAdditionalProductConfigurationInput(e) {
      const input = e.target;
      const value = input.value;
      const name = input.name;

      if (!name || !value) return;

      const correspondingProductFormInput = this.productForm.querySelector(`input[name="${name}"]`);
      if (!correspondingProductFormInput) return;

      correspondingProductFormInput.value = value;
    }
  }
  customElements.define('product-info', ProductInfo);
}
